import { useCartItemsContext } from "../components/cart-context";
import { getMessageTopperPrice } from "../helpers/cake-message-price-helper";
import { getDietaryOptionPrice } from "../helpers/dietary-option-price-helper";
import { getPetiteDecorationPrice } from "../helpers/petite-decoration-price-helper";
import { useCheckoutContext } from "../components/checkout-context";
import { FULFILLMENT } from "../constants";

export default function useCost() {

    const { fulfillment } = useCheckoutContext();
    const messageTopperProduct = getMessageTopperPrice();
    const dietaryOptionProduct = getDietaryOptionPrice();
    const petiteDecorationProduct = getPetiteDecorationPrice();

    const cartItems = useCartItemsContext();

    const hasCakeTopperExtra = (cake) => !!(cake.cakeTopperType && cake.cakeTopperMessage);
    const hasCakeDecorationExtra = (cake) => !!cake.selectedDecoration;

    const hasDietaryOptionExtra = (cake) => (
        cake.selectedDietaryOptionIsDF
        || cake.selectedDietaryOptionIsGF
        || cake.selectedDietaryOptionIsV
    );

    const getCakeWithExtrasAmount = (cake) => 
        cake.selectedPrice
        + (hasCakeTopperExtra(cake) ? messageTopperProduct.price : 0)
        + (hasDietaryOptionExtra(cake) ? dietaryOptionProduct.price : 0) 
        + (hasCakeDecorationExtra(cake) ? petiteDecorationProduct.price : 0);       

    const getCakeAmount = (cake) => cake.quantity * getCakeWithExtrasAmount(cake);

    const isShippingDelivery = fulfillment.fulfillmentType === FULFILLMENT.DELIVERY;

    const shippingRate = isShippingDelivery ? fulfillment.shippingRate : { amount: 0, id: "" };
    const subTotal = cartItems ? cartItems.map(cake => getCakeAmount(cake)).reduce((prev, cur) => prev + cur, 0) : 0;
    const checkOutTotal = subTotal + shippingRate?.amount;
    const gstCost = checkOutTotal - checkOutTotal / 1.15;

    return {
        getCakeAmount,
        hasCakeTopperExtra,
        hasDietaryOptionExtra,
        hasCakeDecorationExtra,
        getCakeWithExtrasAmount,
        isShippingDelivery,
        petiteDecorationProduct,
        messageTopperProduct,
        dietaryOptionProduct,
        shippingRate,
        gstCost,
        checkOutTotal,
        subTotal,
    }
}
